import { AuthService } from 'projects/shared/services/auth.service';
import {
  AfterViewInit,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ProductType } from 'projects/shared/models/enums/productTypes.enum';
import { UserStoreProvider } from 'projects/shared/providers/user.provider';
import { ExchangeService } from 'projects/shared/services/exchange.service';
import { LoadingSpinnerService } from 'projects/shared/services/loading-spinner.service';
import { StoreChangesService } from 'projects/shared/services/store-changes.service';
import { getDateSubtraction, sortWallets } from 'projects/shared/utils/helpers';
import { Observable, Subscription, distinctUntilChanged, filter, noop, tap } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { MainCategory, MainCategory1 } from 'projects/shared/models/category';
import {
  IActiveCurrency,
  Exchange,
} from 'projects/shared/models/interfaces/exchange.model';
import {
  AccountStatus,
  IUser,
  Rank,
} from 'projects/shared/models/interfaces/user.model';
import { WalletService } from 'projects/shared/services/wallet.service';
import { IWallet } from 'projects/shared/models/interfaces/wallet.model';
import { Currency } from 'projects/shared/models/exchange.model';
import { CategoryService } from 'projects/shared/services/category.service';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { SidebarModule } from 'primeng/sidebar';
import { CrispChatService } from 'projects/shared/services/crisp-chat.service';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { LanguageService } from 'projects/shop/src/app/+shared/services/language.service';
import { BrowserService } from 'projects/shared/services/browser.service';
import { DialogModule } from 'primeng/dialog';
import { countriesService } from 'projects/shop/src/app/modules/home/services/countries.service';
import { DropdownModule } from 'primeng/dropdown';
import { NavNotificationsComponent } from './partials/nav-notifications/nav-notifications.component';
import { NavRegionalComponent } from './partials/nav-regional/nav-regional.component';
import { TrimStringPipe } from 'projects/admin/src/app/shared/pipes/trim-string.pipe';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { NotificationService } from 'projects/shared/services/notification.service';
import { NavCartComponent } from './partials/nav-cart/nav-cart.component';
import { subscribe } from 'diagnostics_channel';

@Component({
  selector: 'app-navbar-header',
  templateUrl: './navbar-header.component.html',
  styleUrls: ['./navbar-header.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, ToastModule, SidebarModule, TranslateModule, ToggleButtonModule, DialogModule, ReactiveFormsModule, DropdownModule, NavNotificationsComponent, NavRegionalComponent, TrimStringPipe, OverlayPanelModule, NavCartComponent]
})
export class NavbarHeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('mainCategoryOP') mainCategoryOP!: OverlayPanel;
  @ViewChild('loginOP') loginOP!: OverlayPanel;
  @ViewChild('userSettingOP') userSettingOP!: OverlayPanel;

  unreadNotificationCount = 0;

  cartQuantity = 0;

  arabicLang = false;
  searchTerm!: string;

  searchCountriesKey = '';

  currentCountry!: ({ country: string });

  user!: IUser | null;
  email: any;
  alert: any;
  message: any;
  isLoggedOut = false;
  loadingNav = false;
  loading = false;
  isLoading$: any;

  productType = ProductType;
  searchInput: any;
  accountStatus = AccountStatus;
  userRank = Rank;
  exchange!: Exchange;
  exchangeRate: any;
  currency!: IActiveCurrency;
  mainCategories$: Observable<MainCategory[]> | any;

  selectedCurrency: IActiveCurrency = {
    key: Currency.EGP,
    value: 1,
  };

  currentUrl!: string;
  defaultAvatar = 'https://innostudio.de/fileuploader/images/default-avatar.png';
  subscription: Subscription = new Subscription();
  mainCategoryList?: MainCategory1[];
  changeToCurrentLanguage: any;
  listLinksNav: boolean = false;
  currencyListNav: boolean = false;
  loginListNav: boolean = false;
  userListNav: boolean = false;
  screenWidth!: number;
  disableCurrency = false;
  wallets: any;
  selectedWallet!: Partial<IWallet>;

  newOrNo = false;
  exchangeTwo!: any;
  disableSearch = false;
  lang = '';
  arabic = false;
  country: any;
  countryCode: any;
  showWallet = false;

  constructor(
    private storeChangesServ: StoreChangesService,
    private userStore: UserStoreProvider,
    private router: Router,
    private messageService: MessageService,
    private loadingSpinnerService: LoadingSpinnerService,
    private exchangeServ: ExchangeService,
    private authService: AuthService,
    private walletServ: WalletService,
    private categoryService: CategoryService,
    private crispChatService: CrispChatService,
    public _languageService: LanguageService,
    private _notificationService: NotificationService,
    private _browserService: BrowserService,
    private countriesServices: countriesService,
    private _formBuilder: FormBuilder,
  ) {
    const locationBr = this._browserService.getLocation();
    if (locationBr) {
      this.lang = location.pathname.split('/')[1];
    }
    this.isLoading$ = this.loadingSpinnerService.isLoading$;
    this.getScreenSize();
  }

  ngOnInit(): void {

    this.getNotificationCount();

    this.ChangeAvter();

    this.getCurrentCountry();

    this.checkRoute(this.router.url);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.checkRoute(this.router.url);
      }
    });

    this.getAllMainCategories();

    this.subscription.add(
      this.storeChangesServ.getUser().subscribe({
        next: (response) => {
          this.user = response;
          this.getValidUser();
        },
      })
    );

    // ! Logout at session expired
    this.authService.logoutAtSessionExpired.pipe(
      distinctUntilChanged(),
      tap(
        res => {
          if (this._browserService.getSessionStorage()) {
            if (res && sessionStorage.getItem('token')) {
              this.logout('/auth/signin');
            }
          }
        }
      )
    ).subscribe();

    this.storeChangesServ.getActivatedCurrency().pipe(
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      ),
      tap(
        res => {
          this.selectedCurrency = res;
          if (this.user?._id) this.getWallets();
        }
      )
    ).subscribe();

    this.logOutFromProfile();

    this._languageService.arabic.subscribe(
      res => {
        this.arabic = res;
        this.arabicLang = this.arabic;
        this.lang = this.arabic == true ? 'ar' : 'en';
      }
    );
    this.getCartQuantity();
  }

  ngAfterViewInit(): void {
    this._browserService.getWindow()?.addEventListener('scroll', this.closeOnScroll.bind(this), true);
  }

  closeOnScroll() {
    if (this.mainCategoryOP?.overlayVisible) {
      this.mainCategoryOP.hide();
    }
    if (this.loginOP?.overlayVisible) {
      this.loginOP.hide();
    }
    if (this.userSettingOP?.overlayVisible) {
      this.userSettingOP.hide();
    }
  }

  getCartQuantity() {
    this.subscription.add(
      this.storeChangesServ.getCartNumber().pipe(
        filter(count => count !== null),
        tap(
          count => {
            this.cartQuantity = count;
          }
        )
      ).subscribe()
    )
  }

  getNotificationCount() {
    this.storeChangesServ.getReadNotificationsCount().pipe(
      filter(count => count !== null),
      tap(
        count => {
          this.unreadNotificationCount = count;
        }
      )
    ).subscribe();
  }

  goToSignin() {
    this.loginListNav = false;
    setTimeout(() => {
      this.router.navigate([`/${this.lang}/auth/signin`]);
    }, 0);
  }

  goToSignup() {
    this.loginListNav = false;
    setTimeout(() => {
      this.router.navigate([`/${this.lang}/auth/signup`]);
    }, 0);
  }

  getCurrentCountry() {
    this.authService.currentCountry.pipe(
      distinctUntilChanged(),
      tap(
        res => {
          this.currentCountry = res;
        }
      )
    ).subscribe(noop);
  }

  changeActvatedCuranccy(currency: string) {
    Object.entries(this.exchange).forEach(([key, value]) => {
      if (key === currency) {
        this.selectedCurrency.key = key;
        this.selectedCurrency.value = value;
        localStorage.setItem('activatedCurrency', JSON.stringify(this.selectedCurrency));
        this.storeChangesServ.setActivatedCurrency(this.selectedCurrency);
      }
    });
  }

  getWalletShow() {
    this.storeChangesServ.getWalletShow().subscribe(response => {
      this.showWallet = response;
    });
  }

  isOnCheckoutRoute(): boolean {
    return this.router.url.includes('/checkout');
  }

  getWallets() {
    this.subscription.add(
      this.walletServ.getUserWallets().subscribe({
        next: (response) => {
          if (response && response.length) {
            this.wallets = sortWallets(response, this.selectedCurrency.key).filter((item: IWallet) => {
              return item.currency === this.selectedCurrency.key;
            });
          }
          if (this.wallets?.length > 0) {
            this.selectedWallet = this.wallets[0];
            this.storeChangesServ.setSelectedWallet(this.selectedWallet);
          } else {
            this.selectedWallet = {
              balance: 0,
              currency: this.selectedCurrency.key,
            };
          }

        },
      })
    );
    this.storeChangesServ.getSelectedWallet().pipe(
      filter(wallet => wallet !== null),
      tap(
        wallet => {
          this.selectedWallet = wallet;
        }
      )
    ).subscribe(noop);
  }

  private checkRoute(url: string): void {
    if (url === '/checkout') {
      this.disableCurrency = true;
    } else {
      this.disableCurrency = false;
    }
    if (url.includes('/search')) {
      this.disableSearch = true;
    } else {
      this.disableSearch = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?: any) {
    const windowBr = this._browserService.getWindow();
    if (windowBr) {
      this.screenWidth = window.innerWidth;
    }
  }

  getAllMainCategories() {
    if (this._browserService.getWindow()) {
      if (window.innerWidth <= 768) {
        const query = "?sort=order";
        this.categoryService.getUserMainCategories(query).subscribe((response) => {
          this.mainCategoryList = response.data;
        });
      }
    }
  }

  getValidUser() {
    if (this.user?._id) {
      this.getWallets();
      this.getWalletShow();
      this.loadingNav = true;
    }
  }

  public getDate(date?: string): string {
    return date ? getDateSubtraction(date) : '';
  }

  searchResult(): void {
    if (this.searchTerm) {
      this.router.navigate([`/${this.lang}/search`], {
        queryParams: { name: this.searchTerm },
      });
    }
  }

  clearSearch() {
    this.searchTerm = '';
  }

  logOutFromProfile() {
    this.storeChangesServ.getlogOutFromProfile().pipe().subscribe((response) => {
      if (response == true) {
        this.logout();
        this.storeChangesServ.resetLogOutFromProfile();
      }
    });
  }

  mainCategoriesLocal(mainCategoryName: {}) {
    sessionStorage.setItem('mainCategoryNameFromNavbar', JSON.stringify(mainCategoryName));
  }

  ChangeAvter() {
    this.subscription.add(
      this.storeChangesServ.getAvter().subscribe({
        next: (response) => {
          this.user = response;
        }
      })
    );
  }

  logout(route?: string) {
    this.subscription.add(
      this.userStore.logout$().subscribe({
        next: (response) => {
          this.storeChangesServ.setUser(null);
          this.storeChangesServ.setLoginSecret('');
          this.authService.updateUserShop(null);
          this.crispChatService.crispChat.next('reset');
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'You are Logout Successfully',
          });
          this.loadingNav = false;
          this.user = null;
          this.router.navigateByUrl('/');
          this.getValidUser();
        },
        complete: () => { },
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this._browserService.getWindow()?.removeEventListener('scroll', this.closeOnScroll.bind(this), true);
  }
}